"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuFloating = exports.menu = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_router_dom_1 = require("react-router-dom");
var styles_1 = require("./styles");
exports.menu = [
    { label: 'Inicio', path: '/' },
    { label: 'Nosotros', path: '/about-us' },
    { label: 'Soluciones', path: '/solutions' },
    { label: 'Contactános', path: '/contacts' },
    { label: 'Preguntas frecuentes', path: '/faq' },
];
function MenuFloating(_a) {
    return ((0, jsx_runtime_1.jsxs)(styles_1.Container, { children: [(0, jsx_runtime_1.jsx)("div", {}), (0, jsx_runtime_1.jsx)(styles_1.ContainerNav, { children: exports.menu.map(function (item) { return ((0, jsx_runtime_1.jsx)(react_router_dom_1.NavLink, __assign({ to: item.path }, { children: item.label }), item.label)); }) }), (0, jsx_runtime_1.jsx)("div", {})] }));
}
exports.MenuFloating = MenuFloating;
